import React from 'react';

import { clsx } from 'clsx';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';

import { EMAILS, SOCIAL_LINKS } from './../../constants';

import styles from './SocialLinks.scss';

const SocialLinks = () => {
  const { isMobile } = useLayoutContext();
  const handleButtonClick = ({
    link,
    needPrefix = false,
  }: {
    link: string;
    needPrefix?: boolean;
  }) => {
    const linkPrefix = needPrefix ? 'mailto:' : '';
    window.open(linkPrefix + link, '_blank');
  };

  return (
    <div className={styles.socialLinksContainer}>
      <FadeIn delay={0.2} className={clsx(styles.title, styles.socialLinksTitle)}>
        Connect <span className={clsx(styles.title, styles.titleThin)}> with us</span>
      </FadeIn>
      <FadeIn delay={0.4} className={styles.text}>
        We&rsquo;re here for your questions, {isMobile && <br />}collaboration ideas, and feedback.{' '}
        <br />
        Shape the travel future with&nbsp;us!
      </FadeIn>
      <FadeIn delay={0.6} className={styles.buttonsContainer}>
        <div className={styles.rectangleButtonsContainer}>
          {EMAILS.map((email) => (
            <button
              className={clsx(styles.socialButton, styles.rectangleButton)}
              onClick={() => handleButtonClick({ link: email.link, needPrefix: true })}
              key={email.id}
            >
              {email.link}
            </button>
          ))}
        </div>
        <div className={styles.circleButtonsContainer}>
          {SOCIAL_LINKS.map((item) => (
            <button
              className={clsx(styles.socialButton, styles.circleButton)}
              onClick={() => handleButtonClick({ link: item.link })}
              key={item.id}
            >
              {item.icon}
            </button>
          ))}
        </div>
      </FadeIn>
    </div>
  );
};

export default SocialLinks;
